let Test = require('@/mixins/Forms/2022/NRCA_LTO_02_A')

module.exports = {

    mixins: [Test],

    data() {
        return {
            form: new Form({
                construction_inspection: {
                    name: `Construction Inspection (NA7.8.1.1)`,
                    rows: {
                        row_1: {
                            id: `1`,
                            type: `Boolean`,
                            question: `The motion sensing controls are shown on plan documents and are installed.`,
                            code_reference: `NA7.8.1.1(a)`,
                            answer: false
                        },
                        row_2: {
                            id: `2`,
                            type: `Boolean`,
                            question: `The motion sensor is located to minimize false signals.`,
                            code_reference: `NA7.8.1.1(b)`,
                            answer: false
                        },
                        row_3: {
                            id: `3`,
                            type: `Boolean`,
                            question: `The desired motion sensor coverage is not blocked by obstructions that could adversely affect performance`,
                            code_reference: `NA7.8.1.1(c)`,
                            answer: false
                        },
                    },
                    result: false,
                },
                functional_test: {
                    name: `Functional Testing (NA7.8.1.2)`,
                    rows: {
                        row_1: {
                            id: `1`,
                            type: `Text`,
                            question: `<b>Simulate motion in the area under luminaire controlled by the motion sensor.</b>`,
                            code_reference:`NA7.8.1.2,Step 1`,
                        },
                        row_2: {
                            id: `1.1`,
                            type: `Boolean`,
                            question: `Status indicator operates correctly.`,
                            code_reference: `NA7.8.1.2, Step 1(a)`,
                            answer: false,
                        },
                        row_3: {
                            id: `1.2`,
                            type: `Boolean`,
                            question: `Controlled luminaires turn on immediately upon entry into the controlled area.`,
                            code_reference: `NA7.8.1.2, Step 1(b), Section 130.2(c)3C, Section 160.5(c)2Ciii`,
                            answer: false
                        },
                        row_4:{
                            id:`1.3`,
                            type: `Boolean`,
                            question:`The signal sensitivity is adequate to achieve desired control.`,
                            code_reference: `NA7.8.1.2, Step 1(c)`,
                            answer: false
                        },
                        row_5:{
                            id:`2`,
                            type: `Text`,
                            question:`<b>Simulate no motion in the controlled area.</b>`,
                            code_reference: `NA7.8.1.2, Step 2`,
                        },
                        row_6: {
                            id: `2.1`,
                            type: `Boolean`,
                            question: `The controlled luminaires are turned off or the lighting power of each controlled luminaire is reduced by at least 50% adn no more than 90% within 15 minutes from the start of an unoccupied condition. Fraction of light output reduction is an acceptable proxy for reduction in lighting power.`,
                            code_reference: `NA7.8.1.2, Step2(a), §130.2(c)3B, §130.2(c)3C, §160.5(c)2Cii, §160.5(c)2Ciii`,
                            answer: false
                        },
                        row_7: {
                            id: `2.2`,
                            type: `Boolean`,
                            question: `The sensor does not trigger a false "on" from movement outside of the controlled area.`,
                            code_reference: `NA7.8.1.2, Step 2(b)`,
                            answer: false
                        },
                        row_8:{
                            id:`2.3`,
                            type: `Boolean`,
                            question:`The signal sensitivity is adequate to achieve thedesired control.`,
                            code_reference: `NA7.8.1.2, Step 2(c)`,
                            answer: false
                        }
                    },
                    result: false,
                },
                comments: '',
                testResult: false,
            })
        }
    },

}

